import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { AcmSupaDemoDialogComponent } from './acm-supa-demo-dialog.component'
import { AcmSupaDemo } from '../acm-supa-demo.service'

@Injectable({
  providedIn: 'root',
})
export class AcmSupaDemoDialogService {
  constructor(private dialog: MatDialog) {}

  open(demo: AcmSupaDemo) {
    const defaultConfig: MatDialogConfig = {
      width: '60%',
      maxWidth: '1200px',
      height: 'auto',
      data: { demo },
      panelClass: ['fixed-modal', 'acm-demo-modal'],
      backdropClass: 'cdk-overlay-dark-backdrop-acm-demo',
    }

    return this.dialog.open(AcmSupaDemoDialogComponent, defaultConfig)
  }
}
